namespace GeniuzPOS.ReportMasterData {
    export interface Report_1321Row {
        Id?: string;
        DocDate?: string;
        ShopId?: string;
        ShopName?: string;
        BrandCode?: string;
        BrandName?: string;
        Qty?: number;
        GrossSales?: number;
        AllItemDiscount?: number;
        NetSalesExVat?: number;
        NetSales?: number;
        VatOfNetSales?: number;
        FullName?: string;
    }

    export namespace Report_1321Row {
        export const idProperty = 'Id';
        export const nameProperty = 'ShopId';
        export const localTextPrefix = 'ReportMasterData.Report_1321';
        export const deletePermission = '1POSBASE:รายงาน:สรุปยอดขาย:รายวัน:แยกร้านค้า:View';
        export const insertPermission = '1POSBASE:รายงาน:สรุปยอดขาย:รายวัน:แยกร้านค้า:View';
        export const readPermission = '1POSBASE:รายงาน:สรุปยอดขาย:รายวัน:แยกร้านค้า:View';
        export const updatePermission = '1POSBASE:รายงาน:สรุปยอดขาย:รายวัน:แยกร้านค้า:View';

        export declare const enum Fields {
            Id = "Id",
            DocDate = "DocDate",
            ShopId = "ShopId",
            ShopName = "ShopName",
            BrandCode = "BrandCode",
            BrandName = "BrandName",
            Qty = "Qty",
            GrossSales = "GrossSales",
            AllItemDiscount = "AllItemDiscount",
            NetSalesExVat = "NetSalesExVat",
            NetSales = "NetSales",
            VatOfNetSales = "VatOfNetSales",
            FullName = "FullName"
        }
    }
}
